module.exports = __webpack_public_path__ + "img/agent.fe5b2b43.svg";